<template>
    <!-- 填写邮寄信息 非登录状态页面 -->
    <div class="body-warp" v-if="all && detail" :class="{ disabled }">
        <app-loading :loaded="loaded"></app-loading>
        <div class="form-row">
            <div class="form-label">
                <span class="text">保单号</span>
            </div>
            <div class="form-value">{{ detail.policyNo }}</div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <span class="text">产品名称</span>
            </div>
            <div class="form-value">{{ detail.productName }}</div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <span class="text">投/被保人</span>
            </div>
            <div class="form-value">{{ detail.policyerName + '/' + detail.insuranceName }}</div>
        </div>
        <div class="form-row">
            <div class="form-label required">
                <span class="text">收件人姓名</span>
            </div>
            <input type="text" v-model.trim="formData.receiveName" :disabled="disabled" placeholder="请输入" />
        </div>
        <div class="form-row">
            <div class="form-label required">
                <span class="text">收件人手机号</span>
            </div>
            <input type="text" v-model.trim="formData.receiveMoblie" :disabled="disabled" placeholder="请输入" />
        </div>
        <div class="form-row">
            <div class="form-label required">
                <span class="text">收件人和投保人关系</span>
            </div>
            <div class="select-box">
                <input
                    type="text"
                    :value="all.PAPER_POLICY_RELATIONSHIP[formData.relationship] || ''"
                    placeholder="请选择"
                    readonly
                    :disabled="disabled"
                    @click="showRelationshipSelect = true"
                />
                <i class="icon-xiangxia2" v-if="!disabled"></i>
            </div>
        </div>
        <div class="form-row textarea-content">
            <div class="form-label required">
                <span class="text">收件地址</span>
            </div>
            <van-field
                v-model.trim="formData.receiveAddress"
                type="textarea"
                placeholder="请输入"
                :autosize="{ minHeight: 100 }"
                :disabled="disabled"
                :border="false"
            />
        </div>
        <div class="bottom-box">
            <div class="text-info">注：提交后无法修改相关信息，请确认后提交</div>
            <div class="btn" v-if="$route.query.showBack == 1" @click="back">上一步</div>
            <div class="btn blue" v-if="!disabled" @click="save">提交</div>
        </div>
        <!-- 收件人和投保人关系 选择控件 -->
        <van-popup v-model="showRelationshipSelect" position="bottom">
            <van-picker
                show-toolbar
                title="收件人和投保人关系"
                :columns="columns"
                @confirm="saveRelationship"
                :default-index="relationshipIndex"
            />
        </van-popup>
    </div>
</template>
<script>
import loading from '@/components/loading';
import { common } from '@/api/mixins';
export default {
    mixins: [common],
    data() {
        return {
            all: null,
            loaded: true,
            relationshipIndex: 0,
            showRelationshipSelect: false, // 收件人和投保人关系选择控件显示状态
            columns: [], // 收件人关系列表
            detail: null,
            formData: {}
        };
    },
    components: {
        'app-loading': loading
    },
    computed: {
        disabled() {
            if (!this.detail) return true;
            return this.detail.status != 2;
        }
    },
    async mounted() {
        await this.setAllData();
        this.columns = Object.keys(this.all.PAPER_POLICY_RELATIONSHIP).map(value => ({
            value,
            text: this.all.PAPER_POLICY_RELATIONSHIP[value]
        }));
        this.getPolicyDetail();
    },
    methods: {
        //获取保单信息
        getPolicyDetail() {
            this.loaded = false;
            this.$http({
                type: 'GET',
                url: '/api/content/queryPaperPolicyDetail',
                data: {
                    sign: this.$route.query.sign
                    // id: this.$route.query.id
                }
            })
                .then(res => {
                    this.detail = res.data;
                    if (this.detail.status == 2) {
                        this.formData = {
                            id: res.data.id,
                            receiveName: '',
                            receiveMoblie: '',
                            receiveAddress: '',
                            relationship: ''
                        };
                    } else {
                        this.formData = {
                            id: res.data.id,
                            receiveName: res.data.receiveName,
                            receiveMoblie: res.data.receiveMoblie,
                            receiveAddress: res.data.receiveAddress,
                            relationship: res.data.relationship
                        };
                        // this.relationshipIndex = this.columns.findIndex(item => item.value == this.formData.relationship) || 0;
                    }
                })
                .finally(() => {
                    this.loaded = true;
                });
        },
        // 保存收件人和投保人关系
        saveRelationship(e) {
            if (this.disabled) {
                return;
            }
            this.showRelationshipSelect = false;
            this.$set(this.formData, 'relationship', e.value);
        },
        save() {
            const formData = this.formData;
            if (!formData.receiveName) {
                this.$notice.msg('请输入收件人姓名');
                return;
            }
            if (!formData.receiveMoblie) {
                this.$notice.msg('请输入收件人手机号');
                return;
            }
            if (!this.$regulars.isPhone(formData.receiveMoblie)) {
                this.$notice.msg('请输入正确的收件人手机号');
                return;
            }
            if (!formData.relationship) {
                this.$notice.msg('请选择收件人和投保人关系');
                return;
            }
            if (!formData.relationship) {
                this.$notice.msg('请输入收件地址');
                return;
            }
            if (!this.loaded) {
                return;
            }
            this.loaded = false;
            this.$http({
                type: 'POST',
                url: '/api/content/savePaperPolicyInfo',
                data: formData
            })
                .then(() => {
                    this.$notice.msg('操作成功');
                    this.getPolicyDetail();
                })
                .finally(() => {
                    window.setTimeout(() => {
                        this.loaded = true;
                    }, 300);
                });
        },
        back() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss" scoped>
.body-warp {
    padding: 30px 30px 200px;
    background-color: #fff;
    min-height: 100vh;
    &.disabled {
        .required {
            &::after {
                display: none;
            }
        }
    }
    .form-row {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .form-label {
            font-size: 30px;
            color: #666;
            width: 230px;
            .text {
                display: inline-block;
                max-width: 182px;
                vertical-align: top;
            }
            &.required {
                &::after {
                    content: '*';
                    color: #ff0000;
                    margin-left: 3px;
                }
            }
        }
        .form-value,
        /deep/ textarea,
        input {
            width: 460px;
            height: 80px;
            font-size: 30px;
            color: #333;
            padding-left: 20px;
            padding-right: 20px;
            border: 0;
            background: #f5f5f5;
            border-radius: 10px;
            &[disabled] {
                background: transparent;
                color: #333;
                -webkit-text-fill-color: #333;
                opacity: 1;
                &::placeholder {
                    -webkit-text-fill-color: transparent;
                }
            }
            &::placeholder {
                color: #bfbfbf;
            }
        }
        .form-value {
            background: transparent;
            color: #333;
            display: flex;
            align-items: center;
        }
        .select-box {
            position: relative;
            .icon-xiangxia2 {
                display: inline-block;
                font-size: 36px;
                color: #999;
                position: absolute;
                right: 30px;
                top: 13px;
            }
        }
    }
    .textarea-content {
        align-items: flex-start;
        .form-label {
            padding-top: 15px;
        }
        .van-cell {
            padding: 0;
            width: 460px;
        }
        /deep/ textarea {
            height: 200px;
            padding: 15px 20px;
        }
    }
    .bottom-box {
        width: 690px;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 60px;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .text-info {
            text-align: center; 
            font-size: 28px; 
            color: #888888;
            width: 100%;
            margin-bottom: 15px;
        }
        .btn {
            flex: 1;
            height: 90px;
            border-radius: 10px;
            color: #666666;
            font-size: 32px;
            border: 1px solid #dddddd;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            &.blue {
                background: #236dff;
                color: #fff;
                border: 0;
                margin-left: 20px;
            }
        }
    }
}
</style>
